import _JSXStyle from "styled-jsx/style";
import React, { Children } from 'react';
import Button from "../Button/Button";
import DropdownToggle from "../Dropdown/DropdownToggle";
import Icon from "../Icon/Icon";
var defaultProps = {
  placeholder: 'Click to select an option...'
};

var ComboboxSelections = function ComboboxSelections(_ref) {
  var children = _ref.children,
      onRemoveAll = _ref.onRemoveAll,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? defaultProps.placeholder : _ref$placeholder;

  var handleRemoveAll = function handleRemoveAll(e) {
    e.stopPropagation();
    onRemoveAll === null || onRemoveAll === void 0 ? void 0 : onRemoveAll();
  };

  var handleRemoveAllKeyDown = function handleRemoveAllKeyDown(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      onRemoveAll === null || onRemoveAll === void 0 ? void 0 : onRemoveAll();
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DropdownToggle, {
    caret: true,
    className: "toggler rounded w-100 bg-white form-control py-0 d-flex justify-content-between align-items-center",
    tag: "div",
    tabIndex: 0
  }, Children.count(children) === 0 ? /*#__PURE__*/React.createElement("span", {
    className: "jsx-2207576453" + " " + "user-select-none text-muted"
  }, placeholder) : /*#__PURE__*/React.createElement("div", {
    className: "jsx-2207576453" + " " + "d-flex justify-content-between w-100"
  }, /*#__PURE__*/React.createElement("div", {
    role: "list",
    style: {
      minWidth: '0'
    },
    className: "jsx-2207576453" + " " + "d-flex flex-wrap w-100"
  }, children), /*#__PURE__*/React.createElement(Button, {
    "aria-label": "Remove all selections",
    onClick: handleRemoveAll,
    onKeyDown: handleRemoveAllKeyDown,
    type: "button",
    className: "border-0 bg-white rounded-0 p-0 px-2 m-0"
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "text-muted",
    name: "close"
  })))), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "2207576453"
  }, ".toggler{min-height:32.4px;}.toggler:focus{border-color:#80b7db;box-shadow:inset 0 1px 2px rgb(0 0 0 / 8%),0 0 0 0.25rem rgb(0 110 183 / 25%);outline:0;}"));
};

export default ComboboxSelections;